/*
 * @Author: yeyimei
 * @Date: 2023-04-07 15:08:35
 * @LastEditTime: 2023-12-20 17:11:04
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\libs\jump.js
 */
import { getAppIdStorage, getStorage } from '@/libs/storage'
import { getQueryString } from '@/libs/gcontrol'
const wx = require('weixin-js-sdk')
import router from '../router'
import store from '@/store'
import { getTotalTcTicketAPi } from '@/utils/travel'

export const jumpMethod = async (obj) => {
  const appId = getStorage('appId')
  const infos_storage = getAppIdStorage(appId)
  const environment = getStorage('environment')
  const mercode = infos_storage.mercode
  console.log('打印', obj)
  const type = obj.skipType
  const params = obj.skipInfo
  const thatAppId = obj.skipAppId
  //同程旅行票务访问URL跳转统计
  let hmzx =
    getQueryString('hmzx', obj.skipInfo) || getQueryString('hmzx', obj.skipUrl)
  if (hmzx) {
    let params = {
      hmzx,
      businessCode: mercode,
    }
    await getTotalTcTicketAPi(params)
  }

  if (environment == 'weixin') {
    let url = ''
    let path = ''
    let pathArr = params.split('?')
    if (pathArr.length > 1) {
      //有问号
      path = `${pathArr[0]}&${pathArr[1]}`
    } else {
      path = pathArr[0]
    }
    if (appId === obj.skipAppId) {
      //如果appId相等，当类型为12时不需要跳转打开小程序
      if (type === 2) {
        if (appId === 'wx51103d007a84d074') {
          //乘车码小程序appid:wx51103d007a84d074
          url = `/advertPages/web-view/interactive?type=openWeapp&path=${path}&appid=${thatAppId}`
        } else if (appId === 'wx0a797a7d1b13c050') {
          //管家小程序appid:wx0a797a7d1b13c050
          url = `/pages/cardlan-code/interactive/interactive?type=openWeapp&path=${path}&appid=${thatAppId}`
        } else {
          //便民智惠助手appid:wx9a8fa7157843a99c   便民智充助手appid:wx3b3817860a358835   便民会员助手appid：wx16b33636d4c77e8a
          url = `/pages/webview/interactive?type=openWeapp&path=${path}&appid=${thatAppId}`
        }
        wx.miniProgram.navigateTo({
          url: url,
        })
      } else {
        //跳url分两种情况 1、跳转外部url链接  2、跳转内部页面路径
        if (obj.skipUrl.indexOf('http') >= 0) {
          window.location.href = obj.skipUrl
        } else {
          router.push(obj.skipUrl)
        }
      }
    } else {
      if (type === 2 || type === 12) {
        if (appId === 'wx51103d007a84d074') {
          //乘车码小程序appid
          url = `/advertPages/web-view/interactive?type=openWeapp&path=${path}&appid=${thatAppId}`
        } else if (appId === 'wx0a797a7d1b13c050') {
          //管家小程序appid:wx0a797a7d1b13c050
          url = `/pages/cardlan-code/interactive/interactive?type=openWeapp&path=${path}&appid=${thatAppId}`
        } else {
          //便民智惠助手appid:wx9a8fa7157843a99c   便民智充助手appid:wx3b3817860a358835   便民会员助手appid：wx16b33636d4c77e8a
          url = `/pages/webview/interactive?type=openWeapp&path=${path}&appid=${thatAppId}`
        }
        console.log('打印2222', url)
        wx.miniProgram.navigateTo({
          url: url,
        })
      } else if (type === 1) {
        //跳url分两种情况 1、跳转外部url链接  2、跳转内部页面路径
        if (obj.skipUrl.indexOf('http') >= 0) {
          window.location.href = obj.skipUrl
        } else {
          router.push(obj.skipUrl)
        }
      }
    }
  } else {
    if (type === 1 || type === 12) {
      //跳url分两种情况 1、跳转外部url链接  2、跳转内部页面路径
      if (obj.skipUrl.indexOf('http') >= 0) {
        window.location.href = obj.skipUrl
      } else {
        router.push(obj.skipUrl)
      }
    }
  }
}

//同城旅行跳转
export const travelJump = async (obj, mercode) => {
  let appId = getStorage('appId')
  let environment = getStorage('environment')

  let hmzx =
    getQueryString('hmzx', obj.appPage) || getQueryString('hmzx', obj.h5Url)
  if (hmzx) {
    let params = {
      hmzx,
      businessCode: mercode,
    }
    await getTotalTcTicketAPi(params)
  }
  if (environment === 'weixin') {
    let url

    if (appId === 'wx51103d007a84d074') {
      //乘车码小程序appid
      url = `/advertPages/web-view/interactive?type=openWeapp&path=${encodeURIComponent(
        obj.appPage
      )}&appid=${obj.appId}&opentype=coupon`
    } else if (appId === 'wx0a797a7d1b13c050') {
      //管家小程序appid:wx0a797a7d1b13c050
      url = `/pages/cardlan-code/interactive/interactive?type=openWeapp&path=${encodeURIComponent(
        obj.appPage
      )}&appid=${obj.appId}&opentype=coupon`
    } else {
      //便民智惠助手appid:wx9a8fa7157843a99c   便民智充助手appid:wx3b3817860a358835   便民会员助手appid：wx16b33636d4c77e8a
      url = `/pages/webview/interactive?type=openWeapp&path=${encodeURIComponent(
        obj.appPage
      )}&appid=${obj.appId}&opentype=coupon`
    }
    console.log('打印2222', url)
    wx.miniProgram.navigateTo({
      url: url,
    })
  } else {
    window.location.href = obj.h5Url
  }
}

//根据后端返回的判断业务场景是否停用、维护
export const handleConfigtoPath = (obj, type = '') => {
  //hmPromotionConfigList>promotionType :0-福利首页，10话费充值，20-会员充值，30-吃喝卡券，40-电费充值，50-移动积分,60-肯德基，70-麦当劳，80.商城，90-天天神券，110-会员中心,120-积分中心，121-互动积分，130-土特产,140-同城旅行
  // hmPromotionConfigList> serviceStatus: 0-停用，1-启用，2-维护中
  let typeList = [
    {
      m: 'index',
      path: '/parentCpn/welfare',
      productType: 0,
    },
    {
      m: 'phone',
      path: '/advertPages/phone-recharge/recharge',
      productType: 10,
    },
    {
      m: 'voucher',
      path: '/advertPages/classify/classify',
      path1: '/goods-detail',
      productType: 20,
    },

    {
      m: 'food',
      path: '/dine-libertinism',
      path1: '/setmeal-detail',
      productType: 30,
    },
    {
      m: 'electric',
      path: '/electricity-recharge',
      productType: 40,
    },
    {
      m: 'integral',
      path: '/integral',
      productType: 50,
    },
    {
      m: 'kfc',
      path: '/kfc/home',
      productType: 60,
    },
    {
      m: 'mc',
      path: '/mc/home',
      productType: 70,
    },
    {
      m: 'shop',
      path: '/mall/home',
      path1: '/mall/goods-detail',
      productType: 80,
    },
    {
      m: 'activity',
      path: '/coupon',
      productType: 90,
    },
    {
      m: 'vipNormal',
      m1: 'vipHigh',
      m2: 'vipSuper',
      path: '/member',
      path1: '/local/member',
      productType: 110,
    },

    {
      m: 'points',
      path: '/points-mall/home',
      productType: 121,
    },
    {
      m: 'interactPoints',
      path: '/points-mall/home',
      productType: 120,
    },
    {
      m: 'local',
      path: '/local/home',
      productType: 130,
    },
    {
      m: 'ly',
      path: '/tc-travel',
      productType: 140,
    },
    {
      m: 'movie',
      path: '/movie/home',
      productType: 150,
    },
    {
      m: 'vipActivity',
      path: '/ship-member',
      productType: 160,
    },
  ]
  let hmPromotionConfigList =
    store.getters.getUserConfigInfo?.hmPromotionConfigList || []
  let serviceStatus = 1
  let _tmp = null

  //页面跳转路由path判断
  if (type === 'router') {
    _tmp = typeList.find(
      (item) => item.path === obj.path || item.path1 === obj.path
    )
  } else {
    //页面跳转url中m参数判断
    _tmp = typeList.find(
      (item) => item.m === obj.m || item.m1 === obj.m || item.m2 === obj.m
    )
  }
  console.log('_tmp=====', _tmp)

  hmPromotionConfigList.forEach((item) => {
    if (item.promotionType === _tmp?.productType) {
      serviceStatus = item.serviceStatus
    }
  })
  return serviceStatus
}
